/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface ProductProfitabilitySummaryData
 */
export interface ProductProfitabilitySummaryData {
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    profitableProducts?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    lossProducts?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    productsWithoutPurchasePrice?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    turnover?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    purchasePrice?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    grossMargin?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    allocatedMarketingSpend?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    profitAfterMarketing?: MoneyOutput;
}

/**
 * Check if a given object implements the ProductProfitabilitySummaryData interface.
 */
export function instanceOfProductProfitabilitySummaryData(value: object): value is ProductProfitabilitySummaryData {
    return true;
}

export function ProductProfitabilitySummaryDataFromJSON(json: any): ProductProfitabilitySummaryData {
    return ProductProfitabilitySummaryDataFromJSONTyped(json, false);
}

export function ProductProfitabilitySummaryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductProfitabilitySummaryData {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'profitableProducts': json['profitableProducts'] == null ? undefined : json['profitableProducts'],
        'lossProducts': json['lossProducts'] == null ? undefined : json['lossProducts'],
        'productsWithoutPurchasePrice': json['productsWithoutPurchasePrice'] == null ? undefined : json['productsWithoutPurchasePrice'],
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
        'purchasePrice': json['purchasePrice'] == null ? undefined : MoneyOutputFromJSON(json['purchasePrice']),
        'grossMargin': json['grossMargin'] == null ? undefined : MoneyOutputFromJSON(json['grossMargin']),
        'allocatedMarketingSpend': json['allocatedMarketingSpend'] == null ? undefined : MoneyOutputFromJSON(json['allocatedMarketingSpend']),
        'profitAfterMarketing': json['profitAfterMarketing'] == null ? undefined : MoneyOutputFromJSON(json['profitAfterMarketing']),
    };
}

export function ProductProfitabilitySummaryDataToJSON(json: any): ProductProfitabilitySummaryData {
    return ProductProfitabilitySummaryDataToJSONTyped(json, false);
}

export function ProductProfitabilitySummaryDataToJSONTyped(value?: ProductProfitabilitySummaryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'profitableProducts': value['profitableProducts'],
        'lossProducts': value['lossProducts'],
        'productsWithoutPurchasePrice': value['productsWithoutPurchasePrice'],
        'turnover': MoneyOutputToJSON(value['turnover']),
        'purchasePrice': MoneyOutputToJSON(value['purchasePrice']),
        'grossMargin': MoneyOutputToJSON(value['grossMargin']),
        'allocatedMarketingSpend': MoneyOutputToJSON(value['allocatedMarketingSpend']),
        'profitAfterMarketing': MoneyOutputToJSON(value['profitAfterMarketing']),
    };
}

